import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import ContactSection from '../components/home/ContactSection';
import './ContactPage.css';

const ContactPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="contact-page"
    >
      <Helmet>
        <title>Contact ZustandTech | Get a Free Software Development Quote</title>
        <meta
          name="description"
          content="Get in touch with ZustandTech (Zustand Tech Software Private Limited) for web development, mobile apps, AI solutions, and cloud services. Based in Chinhat, Lucknow, serving clients worldwide."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.zustandtech.com/contact" />

        <meta property="og:title" content="Contact ZustandTech" />
        <meta
          property="og:description"
          content="Reach out to ZustandTech for your next software development project."
        />
        <meta property="og:url" content="https://www.zustandtech.com/contact" />
        <meta property="og:type" content="website" />
      </Helmet>

      <ContactSection />

      <section className="map-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="map-container"
          >
            {/* ✅ Updated iframe with Chinhat, Lucknow address */}
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3559.123456789!2d80.9903733!3d26.8456506!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399be7a8e5c5b0c9%3A0x7b6a6f9b4c7e2b6d!2sChinhat%2C%20Lucknow%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="ZustandTech Office - Chinhat, Lucknow"
            ></iframe>
          </motion.div>
        </div>
      </section>
    </motion.div>
  );
};

export default ContactPage;